import { receiptApiClient, bxApiClient } from "@shared/api/clients/apiClientFactory";
import { ApiEndpoints } from "@shared/api/api-endpoints";
import { DashboardCardsResponse } from "./types";

export const billTemplateV3Api = {
  getAccountTypeChoices: async (utilityId: number): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "bx",
      "choices/account-type",
      (query) => {
        query.push("remote_utility_id", utilityId);
      }
    );
    const response = await bxApiClient.get(url);
    return response.data;
  },

  getDashboardCards: async (
    remoteUtilityId: string | number,
    filters?: { search?: string; accountType?: string; status?: string }
  ): Promise<DashboardCardsResponse> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "receipt",
      "dashboard-cards",
      (query) => {
        query.push("remote_utility_id", remoteUtilityId);
        if (filters?.search) query.push("search", filters.search);
        if (filters?.accountType) query.push("account_type", filters.accountType);
        if (filters?.status) query.push("is_active", filters.status);
      }
    );
    const response = await receiptApiClient.get(url);
    return response.data;
  },

  getTemplateSummary: async (
    remoteUtilityId: string | number
  ): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "bx",
      "template-summary",
      (query) => {
        query.push("remote_utility_id", remoteUtilityId);
      }
    );
    const response = await receiptApiClient.get(url);
    return response.data;
  },

  getUtilityPlans: async (
    remoteUtilityId: string | number
  ): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "receipt",
      "utility-plans",
      (query) => {
        query.push("remote_utility_id", remoteUtilityId);
      }
    );
    const response = await receiptApiClient.get(url);
    return response.data;
  },

  getReceiptPreview: async (
    templateId:string,
    planId: string | number | undefined,
    remoteUtilityId: string | number,
    isDownload: boolean = false,
    cardType?: string
  ): Promise<any> => {
    const isMaster = cardType?.toLowerCase() === 'master';
    const endpointPath = isMaster 
      ? `generate-master-receipt` 
      : `generate-receipt/${templateId}`;

    const url = ApiEndpoints.createUrlWithQueryParameters(
      "receipt",
      endpointPath,
      (query) => {
        query.push("remote_utility_id", remoteUtilityId);
        if (!isMaster && planId !== undefined) {
          query.push("plan_id", planId.toString());
        }
        !isDownload && query.push("format", "html");
      }
    );
    const config = isDownload ? { responseType: "blob" as const } : undefined;
    const response = await receiptApiClient.get(url, config);
    return response.data;
  },
};
